import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { siteListAtom } from '@/interfaces/verify';
import { useAtom } from 'jotai';
import { selectedSiteAtom } from './constants';
export default function SiteListCompo() {
  const [{ data }] = useAtom(siteListAtom);
  const [selectedSite, setSelectedSite] = useAtom(selectedSiteAtom);
  return (
    <FormControl fullWidth>
      <InputLabel id="site-label">Site</InputLabel>
      <Select
        id="Site"
        size="medium"
        label="Site"
        labelId="site-label"
        value={selectedSite}
        onChange={(e) => setSelectedSite(Number(e.target.value))}
      >
        {data &&
          data.map((item: any, index: number) => (
            <MenuItem key={index} value={item.site_id}>
              {item.nickname}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
